import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-180e0d27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-solution-content-wrap" }
const _hoisted_2 = { class: "terminal-solution-content" }
const _hoisted_3 = { class: "terminal-solution-content-fifth-block-text margin-l-r second fourth" }

import {
  terminal_solution_content_menu_block,
  terminal_solution_content_sixth_block,
  terminal_solution_content_seventh_block,
  terminal_solution_content_fifth_block,
  terminal_solution_content_first_block,
  terminal_solution_content_fourth_block,
  terminal_solution_content_second_block,
  terminal_solution_content_third_block,
} from "@/features";
import {useLocalizationStore,} from "@/shared";
import {WrapTitle} from "@/entities";


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-solution-content',
  setup(__props) {

const {translate} = useLocalizationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(terminal_solution_content_menu_block)),
      _createVNode(_unref(WrapTitle), {
        text: _unref(translate)('self_service_terminals'),
        size: "regular",
        weight: "700",
        class: "margin-l-r"
      }, null, 8, ["text"]),
      _createVNode(_unref(terminal_solution_content_first_block), { id: "cash" }),
      _createVNode(_unref(terminal_solution_content_second_block), { id: "pos" }),
      _createVNode(_unref(terminal_solution_content_third_block), { id: "cryptomat" }),
      _createVNode(_unref(terminal_solution_content_fourth_block), { id: "creditomat" }),
      _createVNode(_unref(terminal_solution_content_fifth_block), { id: "selfservice" }),
      _createVNode(_unref(terminal_solution_content_sixth_block), { id: "androidapp" }),
      _createVNode(_unref(terminal_solution_content_seventh_block), { id: "faceid" }),
      _createVNode(_unref(WrapTitle), {
        text: _unref(translate)('did_you_not_find_solution'),
        class: "terminal-solution-content-fifth-block-title margin-l-r",
        size: "regular",
        weight: "700"
      }, null, 8, ["text"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(translate)("we_are_here_to_help")), 1),
      _createVNode(_unref(WrapTitle), {
        text: _unref(translate)('do_not_settle_for_less'),
        class: "terminal-solution-content-fifth-block-title margin-l-r",
        size: "light",
        weight: "700"
      }, null, 8, ["text"])
    ])
  ]))
}
}

})